/**
 * @file     ToolSection.tsx
 * @purpose  A section under a family 7 tool: hairline rule, kit section
 *           header, then the content. Matches the hub section rhythm.
 */
import Box from '@mui/material/Box';
import { SectionHeader } from '@/components/hub/SectionHeader';
import { hairline } from '@/components/hub/hubKitStyles';

type ToolSectionProps = {
  title: string;
  description?: string;
  id?: string;
  children: React.ReactNode;
};

export function ToolSection({ title, description, id, children }: ToolSectionProps) {
  return (
    <Box component="section" id={id} sx={{ mt: { xs: 6, md: 9 }, pt: { xs: 4, md: 5 }, borderTop: hairline, scrollMarginTop: 96 }}>
      <Box sx={{ mb: { xs: 3, md: 4 } }}>
        <SectionHeader title={title} description={description} />
      </Box>
      {children}
    </Box>
  );
}
